import React, { useState } from 'react';
import SimulatedDataSelector from '../../../components/SimulatedDataSelector';
import { useTheme } from '../../../__state/ThemeContext';
import config from '../../../utils/config';

import './SimulationView.scss';

const SimulationView = () => {
  const { theme } = useTheme();
  const selfData = JSON.parse(sessionStorage.getItem('selfData'));
  const showMetricOnly = selfData?.metricValOn || false;

  const [simulatedEntry, setSimulatedEntry] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const handleDataSelected = (parsed, message) => {
    setSimulatedEntry(parsed);
    setSelectedMessage(message);
  };

  // Calculate status values from parsed entry
  const getStatusValues = (entry) => {
    if (!entry) return {};

    const isLightningActive =
      entry.lightningFreq &&
      !isNaN(entry.lightningFreq.value) &&
      parseInt(entry.lightningFreq.value) > 0;

    const isRainActive =
      entry.precip &&
      !isNaN(entry.precip.value) &&
      parseFloat(entry.precip.value) > 0;

    const isCloudsActive =
      entry.cloudLayers &&
      entry.cloudLayers.value !== 'No Ceilometer' &&
      entry.cloudLayers.value !== 'NCD' &&
      entry.cloudLayers.value !== 'CLR' &&
      entry.cloudLayers.value !== 'Ceilometer OFF';

    const batteryValue = entry.battery ? parseFloat(entry.battery.value) : 0;
    const batteryLevel =
      batteryValue >= 5 ? 'good' : batteryValue >= 4.8 && batteryValue < 5 ? 'meh' : 'bad';

    return {
      isLightningActive,
      isRainActive,
      isCloudsActive,
      isTamperingActive: false, // No historical data to compare
      batteryLevel,
    };
  };

  const statusValues = getStatusValues(simulatedEntry);

  return (
    <div className="simulation-view" data-theme={theme}>
      <div className="simulation-header">
        <div className="header-content">
          <h3>IWOS Data Simulation Testing</h3>
          <p className="subtitle">
            Select a simulated message to test the Table and Dashboard displays
          </p>
        </div>
      </div>

      <SimulatedDataSelector
        onDataSelected={handleDataSelected}
        showRawMessage={true}
      />

      {simulatedEntry && (
        <div className="simulated-data-display">
          {/* Table View */}
          <div className="display-section">
            <h4 className="section-title">Table View</h4>
            <div className="table-container">
              {config['IWOS']['table']({
                row: simulatedEntry,
                deviceTypeOfficial: 'IWOS Simulated',
                deviceName: selectedMessage?.name || 'Simulation',
                deviceImei: simulatedEntry.imei?.value || 'SIMULATED',
                highlightedKeys: [],
                data1HourAgo: null,
                showMetricOnly,
              })}
            </div>
          </div>

          {/* Dashboard View */}
          <div className="display-section">
            <h4 className="section-title">Dashboard View</h4>
            <div className="dashboard-container dashboard-view" data-theme={theme}>
              {config['IWOS']['dashboard']({
                latestEntry: simulatedEntry,
                isLightningActive: statusValues.isLightningActive,
                isRainActive: statusValues.isRainActive,
                isCloudsActive: statusValues.isCloudsActive,
                isTamperingActive: statusValues.isTamperingActive,
                batteryLevel: statusValues.batteryLevel,
                showMetricOnly,
                theme,
              })}
            </div>
          </div>

          {/* Parsed Data Debug View */}
          <div className="display-section">
            <h4 className="section-title">Parsed Data (Debug)</h4>
            <div className="debug-container">
              <pre className="parsed-json">
                {JSON.stringify(simulatedEntry, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      )}

      {!simulatedEntry && (
        <div className="no-selection">
          <p>Select a simulated message above to preview the parsed data</p>
        </div>
      )}
    </div>
  );
};

export default SimulationView;
